module.exports = __webpack_public_path__ + "img/42.2e74828c.jpg";